import { render, staticRenderFns } from "./SpecialOfferBanner.vue?vue&type=template&id=087fc3a0&scoped=true&"
import script from "./SpecialOfferBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SpecialOfferBanner.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SpecialOfferBanner.vue?vue&type=style&index=0&id=087fc3a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087fc3a0",
  null
  
)

export default component.exports